import React, { useContext, useEffect, useRef, useState } from "react";
import { environmentVariables } from "../../config/env.config";
import { userContext } from "../../context/userContext";
import PageName from "../Utils/PageName";
import DataTable from "react-data-table-component";
import SortIcon from "@material-ui/icons/ArrowDownward";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { useTranslation } from "react-i18next";
import axios from "axios";
import CircularLoader from "../Components/CircularLoader/CircularLoader";
import { formatDateTime } from "../Components/DateTimeFormat/DateTimeFormat";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { subtractDays } from "../../utils/utility";
import Sheet from "@mui/joy/Sheet";
import moment from "moment";
import { Modal, ModalClose, Typography } from '@mui/joy';
import { FaCalendarAlt } from 'react-icons/fa';
import "./CustomPaymentHistoryStyle.css";
import DownloadExcel from "../../../src/Images/downloadExcel.svg";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { ToastContainer, toast } from "react-toastify";
import CalendarFilter from "../Components/DateTimeFormat/CalenderPopup";
import NewFilterIcon from "../../../src/Images/newFilter.svg";
import { CalenderDrawer } from "../Components/DateTimeFormat/CalenderDrawer";

const CustomPaymentHistory = () => {
  const baseUrl = environmentVariables?.apiUrl;
  const { t } = useTranslation();

  const { userData } = useContext(userContext);
  const [responseData, setResponseData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [countryData, setCountryData] = useState([]);
  const [activeCountry, setActiveCountry] = useState("");
  const [PaymentStatus, setPaymentStatus] = useState("");
  const [selectedDateFrom, setSelectedDateFrom] = useState("");
  const [selectedDateTo, setSelectedDateTo] = useState("");
  const [nameOrderId, setNameOrderId] = useState("");
  const abortController = new AbortController();
  const fromDate = useRef(null);
  const toDate = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [open, setOpen] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const [filter, setFilter] = useState(false)

  const tableExtensions = {
    export: false,
    print: false,
  };

  function useWindowWidth() {
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
      const handleResize = () => setWidth(window.innerWidth);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
    return width;
  }

  const windowWidth = useWindowWidth();

  const handleViewMessage = (d) => {
    setOpen(true);
    setSelectedMessage(d);
    setIsModalOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
    setIsModalOpen(false);
  };


  const getStatusStyle = (status) => {
    const styles = {
      failed: { color: "#e71c1f", background: "#e71c1f33" },
      pending: { color: "#ffa401", background: "#ffa40133" },
      complete: { color: "#2892D5", background: "#2892D533" },
      settled: { color: "#26a56a", background: "#26a56a33" },
      transaction_not_paid_yet: { color: "#ff6600", background: "#ff660033" },
    };

    const { color = "#000", background = "#00000033" } = styles[status] || {};

    return {
      fontWeight: "500",
      color,
      background,
      borderRadius: "4px",
      padding: "2px 0px",
      textTransform: "capitalize",
      minWidth: "90px",
      maxWidth: "90px",
      display: "block",
      textAlign: "center",
    };
  };

  const columns = [
    {
      name: t("Order_id"),
      selector: (row) =>
        row?.payment_method == 'TOTALPAY'
          ? row?.custom_payments_data?.order_id || "--" : row?.custom_payments?.order_id || "--",
      sortable: true,
      cell: (row) => (
        <div className="custom-cell order-id-cell custom-cell-bold" data-column-name={t("Order_id")}>
          {row?.payment_method == 'TOTALPAY'
            ? row?.custom_payments_data?.order_id || "--" : row?.custom_payments?.order_id || "--"}
        </div>
      ),
      // width: windowWidth > 768 ? "15%" : "100%",
      minWidth: windowWidth > 768 ? "180px" : "100%",

    },
    {
      name: t("Amount"),
      selector: (row) => {
        let currency = row?.currency === "د." || row?.currency === "AED" ? "AED" : (row?.currency)
        if (currency === "AED") {
          return `${row?.amount} ${currency}` || "--"
        } else {
          return `${currency}${row?.amount}` || "--"
        }
      },
      cell: (row) => (
        <div className="custom-cell custom-cell-bold" data-column-name={t("Amount")}>
          {
            row?.amount == null
              ? "--"
              : row?.currency === "د." || row?.currency === "AED"
                ? `${row.amount} ${row?.currency}`
                : `${row.currency}${row.amount}`
          }
        </div>
      ),
      sortable: true,
      // width: "15%",
      minWidth: "180px",

    },  
    {
      name: t("Payment_status"),
      selector: (row) => row?.payment_status || "--",
      cell: (row) => (
        <div className="custom-cell custom-cell-bold" data-column-name="Payment_status" >
          <span style={getStatusStyle(row?.payment_status)}>{row?.payment_status == 'Transaction_not_paid_yet' ? "Unpaid" : row?.payment_status || "--"}</span>
        </div>
      ),
      sortable: true,
      // width: windowWidth > 768 ? "15%" : "100%",
      minWidth: windowWidth > 768 ? "180px" : "100%",

    },
    {
    name: t("Transaction ID"),
    selector: (row) => {
      if (row?.payment_method === "TOTALPAY") {
        return row?.custom_payments_data?.order_number || "--";
      }
      return row?.pay_id || "--";
    },
    cell: (row) => {
      const displayValue = row?.payment_method === "TOTALPAY"
        ? row?.custom_payments_data?.order_number || "--"
        : row?.pay_id || "--";

      return (
        <div className="custom-cell custom-cell-bold" data-column-name="Transaction ID">
          <span style={{
            maxWidth: "350px",
            width: "50%",
            textOverflow: "ellipsis",
            overflow: "hidden",
            display: "block",
            textAlign: "end"
          }}>
            {displayValue}
          </span>
        </div>
      );
    },
    minWidth: "200px"
    },
    {
      name: "Action",
      sortable: false,
      cell: (d) => (
        <div onClick={() => handleViewMessage(d)}
          style={{ cursor: "pointer", marginRight: "0px", width: "100%" }}>
          {windowWidth > 768 ? <i
            className="first fas fa-eye"

          ></i> : <p style={{ textDecoration: "underline", width: "100%", textAlign: "right", fontSize: "14px" }}>View Details</p>
          }</div>

      ),
      minWidth: "180px"
    }
  ];

  const customStyles = {
    headRow: {
      style: {
        // width: "100%",
        backgroundColor: "#E9E9E9",
        minHeight: "52px",
        borderRadius: "2px 2px 0px 0px",
        padding: "8px 25px",
        border: "none",
        textAlign: "left",
      },
    },
    headCells: {
      style: {
        color: "#525252",
        fontSize: "16px", // Same font size as regular cells
        minHeight: "52px",
        padding: "8px 10px", // Same padding as regular cells
        textAlign: "left",
      },
    },
    rows: {
      style: {
        padding: "6px 0px 6px 25px", // Ensure similar padding here
        fontSize: "13px", // Match font size with header
        textTransform: "capitalize",
        minHeight: "48px !important",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
      },
    },
    cells: {
      style: {
        // minWidth: "50px !important",
        padding: "0px 5px", // Same padding as header cells
        fontSize: "13px", // Match font size with header
        textAlign: "left", // Ensure same text alignment as header
      },
    },
  };

  const tableData = {
    columns,
    data: responseData,
  };
  const paginationOptions = {
    rowsPerPageText: t("Rows_per_page"),
    rangeSeparatorText: t("Of"),
    noRowsPerPage: false,
    selectAllRowsItem: false,
    // selectAllRowsItemText: t("All"),
  };

  async function fetchData(page, size = perPage) {
    try {
      const response = await axios.get(
        `${baseUrl}api/v1/custompayment/get_all_custom_payments?countryCode=${activeCountry}&fromDate=${selectedDateFrom}&toDate=${selectedDateTo}&nameOrderId=${nameOrderId}&page=${page}&limit=${size}&paymentStatus=${PaymentStatus}`,
        {
          headers: {
            _token: userData?.token,
          },
          signal: abortController.signal,
        }
      );
      if (response.status === 200) {
        const { data, totalRecords, countries, currentPage } = response?.data;
        setCountryData(countries)
        setResponseData(data);
        setTotalRows(totalRecords || 0);
        setCurrentPage(currentPage)
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      setResponseData([]);
    }
  }
  useEffect(() => {
    fetchData(1);
    return () => {
      abortController.abort();
    };
  }, [
    activeCountry,
    selectedDateFrom,
    selectedDateTo,
    nameOrderId,
    PaymentStatus
    // currentPage,
    // perPage
  ]);

  const handleReset = () => {
    setSelectedDateFrom("");
    setSelectedDateTo("");
    setNameOrderId("");
    setActiveCountry("");
    setPaymentStatus("");
  };

  const handlePageChange = (page) => {
    fetchData(page);
  };

  const handleChangeCountryData = (e) => {
    const countryName = e.target.value;
    setActiveCountry(countryName);
  };

    const handleChangePaymentStatus = (e) => {
    const data = e.target.value;
    setPaymentStatus(data);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    fetchData(page, newPerPage);
  };

  const exportToExcel = async () => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    if (!selectedDateFrom || !selectedDateTo) {
      toast.error(("Please select both 'From' and 'To' dates to export."), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
      return;
    }

    try {
      const response = await axios.get(
        `${baseUrl}api/v1/custompayment/get_all_custom_payments?countryCode=${activeCountry}&fromDate=${selectedDateFrom}&toDate=${selectedDateTo}&nameOrderId=${nameOrderId}&page=1&limit=1000`,
        {
          headers: {
            _token: userData?.token,
          },
          signal: abortController.signal,
        }
      );

      const usersAllData = response?.data?.data || [];
      const formattedData = usersAllData.map((item) => ({
        CustomerName: item?.customer_name || "--",
        CustomerEmail: item?.customer_email || "--",
        Contact: `${item?.phone_code || "+91"} ${item?.phone || ""}`,
        BusinessName: item?.businesses?.title || "--",
        BusinessOwnerName: item?.businesses?.sub_title || "--",
        Amount: item?.currency === "د." ? `${item?.amount} AED` : `${item?.currency}${item?.amount}`,
        SettlementAmount: item?.currency === "د." ? `${item?.settlement_amount} AED` : `${item?.currency}${item?.settlement_amount}`,
        SettlementFee: item?.currency === "د." ? `${item?.settlement_fee} AED` : `${item?.currency}${item?.settlement_fee}`,
        SettlementTime: item?.updated_at
          ? new Date(item.updated_at).toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          })
          : "--",
        CreatedAt: item?.created_at
          ? new Date(item.created_at).toLocaleDateString("en-GB")
          : "--",
        OrderId: item?.custom_payments?.order_id || "--",
        PaymentStatus: item?.payment_status || "--",
      }));

      const ws = XLSX.utils.json_to_sheet(formattedData);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });

      const fileName = `Payin_History_${new Date()
        .toISOString()
        .split("T")[0]}${fileExtension}`;

      saveAs(data, fileName);
    } catch (error) {
      console.error("Export to Excel failed:", error);
    }
  };

  const handleFilter = () => {
    setFilter(!filter)
  }

  const handleDateFilter = (date) => {
    if (
      date &&
      date.from instanceof Date &&
      !isNaN(date.from) &&
      date.to instanceof Date &&
      !isNaN(date.to)
    ) {
      const fromDate = date.from.getTime();
      const toDate = date.to.getTime();

      setSelectedDateFrom(fromDate);
      setSelectedDateTo(toDate);
    }
    if (date == 'reset') {
      handleReset();
    }
  }

  return (
    <>
      <div id="custom_table" className="payInHistory">
        <PageName PageName="Pay-in History" />

        <div className="superadminsearch_style upperFilter">

          <input
            type="text"
            // class="form-control clear_string"
            class="superadminsearchinput"
            placeholder={"Search By Business Name, OrderId"}
            value={nameOrderId}
            onChange={(e) => setNameOrderId(e.target.value)}
            style={{ width: "300px" }}
          />

          <div className="upperFilter" style={{ margin: "0" }}>
            {userData?.user_type == "super_admin" && (
              <div className="selectCountry" style={{ width: "160px" }}>
                <select
                  style={{ cursor: "pointer" }}
                  value={activeCountry}
                  onChange={(e) => handleChangeCountryData(e)}
                  class="form-select"
                >
                  {""}
                  <option value={""}>{t("Select_country")}</option>
                  {countryData &&
                    countryData.map((val, index) => (
                      <option key={index} value={val?.phone_code}>
                        {val?.country}
                      </option>
                    ))}
                </select>
              </div>
            )}

            
            <div className="filterWrapper">

 <div className="selectCountry" style={{ width: "160px" }}>
                <select
                  style={{ cursor: "pointer" }}
                  value={PaymentStatus}
                  onChange={(e) => handleChangePaymentStatus(e)}
                  class="form-select"
                >
                  {""}
                  <option value={""}>{t("Payment_status")}</option>
                  <option value={"complete"}>Complete</option>
                  <option value={"failed"}>Failed</option>
                  <option value={"pending"}>Pending</option>
                  <option value={"settled"}>Settled</option>
                  
                </select>
              </div>
              {windowWidth > 768 ? (
                <CalendarFilter t={t} handleDateFilter={handleDateFilter} />
              ) : (
                <>
                <div className="FilterIcon user-filter" onClick={handleFilter}>
                  <div className="filtertext">{t("Filter")} <img loading="lazy" src={NewFilterIcon} width={28} /></div>
                </div>
                <CalenderDrawer filter={filter} handleFilter={handleFilter} handleDateFilter={handleDateFilter} t={t} />
                </>
              )}


              <div> <button
                className=" d-flex btn-primary gap-1 bg-transparent border-0 excel-button"
                onClick={exportToExcel}
                style={{ padding: "0 0 0 10px" }}
              >
                {" "}
                <img src={DownloadExcel} style={{ width: "25px" }} />
                <span className="clearFilter" >{t("Export")}</span>
              </button></div>
            </div>
          </div>
        </div>


        <div className="main">
          {isLoading ? (
            <CircularLoader size={40} />
          ) : (
            <>
              <DataTableExtensions
                {...tableExtensions}
                {...tableData}
                customStyles={customStyles}
                filterPlaceholder="Search User By name"
              >
                <DataTable
                  className="customDataTable"
                  columns={columns}
                  data={responseData}
                  noHeader
                  defaultSortField="id"
                  sortIcon={<SortIcon />}
                  defaultSortAsc={true}
                  pagination
                  paginationServer
                  paginationRowsPerPageOptions={[10, 15, 20, 25, 30]}
                  paginationTotalRows={totalRows}
                  onChangePage={handlePageChange}
                  onChangeRowsPerPage={handlePerRowsChange}
                  highlightOnHover
                  dense
                  // paginationPerPage={perPage}
                  paginationComponentOptions={{
                    ...paginationOptions,
                  }}
                  progressPending={isLoading}
                  customStyles={customStyles}
                  noDataComponent={
                    <div style={{ padding: "24px" }}>{t("No_records_found")}</div>
                  }
                />
              </DataTableExtensions>
            </>
          )}
        </div>
      </div>

      <Modal
        aria-labelledby="modal-title"
        aria-describedby="modal-desc"
        open={open}
        onClose={() => hideModal()}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Sheet
          variant="outlined"
          sx={{
            maxWidth: 500,
            minWidth: 390,
            borderRadius: "md",
            p: 3,
            boxShadow: "lg",
          }}
          className="paymentInfproductdetails"
        >
          <ModalClose variant="plain" sx={{ m: 1 }} />
          <Typography
            component="h2"
            id="modal-title"
            level="h4"
            textColor="inherit"
            fontWeight="lg"
            mb={2}
            textAlign="center"
          >
            {t("Order_details_small")}
          </Typography>
          <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}><span>{t("Business_name")}:</span><span style={{ fontWeight: "700" }}>{selectedMessage?.businesses?.title || "--"}</span></div>
            <div style={{ display: "flex", justifyContent: "space-between" }}><span>{t("Date")}:</span><span style={{ fontWeight: "700" }}>{moment(selectedMessage?.created_at).format("DD-MMM-YYYY HH:mm:ss")}</span></div>
            <div style={{ display: "flex", justifyContent: "space-between" }}><span>{t("Customer_name")}:</span><span style={{ fontWeight: "700" }}>{selectedMessage?.customer_name}</span></div>
            <div style={{ display: "flex", justifyContent: "space-between" }}><span>{t("Customer_email")}:</span><span style={{ fontWeight: "700" }}>{selectedMessage?.customer_email}</span></div>
            <div style={{ display: "flex", justifyContent: "space-between" }}><span>{t("settlement_amount")}:</span><span style={{ fontWeight: "700" }}>{selectedMessage?.settlement_amount == null ? "--" : selectedMessage?.currency === "د." || selectedMessage?.currency === "AED" ? `${selectedMessage.settlement_amount} AED` : `${selectedMessage.currency}${selectedMessage.settlement_amount}`}   </span></div>
            <div style={{ display: "flex", justifyContent: "space-between" }}><span>{t("settlement_fee")}:</span><span style={{ fontWeight: "700" }}>{selectedMessage?.settlement_fee == null ? "--" : selectedMessage?.currency === "د." || selectedMessage?.currency === "AED" ? `${selectedMessage.settlement_fee} AED` : `${selectedMessage.currency}${selectedMessage.settlement_fee}`} </span></div>
            <div style={{ display: "flex", justifyContent: "space-between" }}><span>{t("settlement_time")}:</span><span style={{ fontWeight: "700" }}>{`${selectedMessage?.settlement_time}h`}</span></div>
            <div style={{ display: "flex", justifyContent: "space-between" }}><span>{t("Payment_status")}:</span><span style={getStatusStyle(selectedMessage?.payment_status)}>{selectedMessage?.payment_status}</span></div>
            <div style={{ display: "flex", justifyContent: "space-between" }}><span>{t("Tx_ID")}:</span><span style={{ fontWeight: "700", wordBreak: "break-all" }}>{selectedMessage?.payment_method === "TOTALPAY" ? selectedMessage?.custom_payments_data?.order_number || "--": selectedMessage?.pay_id || "--"}</span></div>

          </div>
        </Sheet>
      </Modal>
    </>
  );
};

export default CustomPaymentHistory;
